import { fetchCourseCoursewareFavoriteList } from '@/api/app/course';
export default {
  data() {
    return {
      courseCoursewareId: undefined, // courseCourseware id
      courseCoursewareFavoriteLoaded: false,
      courseCoursewareFavoriteData: [],
      courseCoursewareFavoritePage: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
        pageSizes: [10, 20, 50, 100],
        layout: 'total, sizes, prev, pager, next, jumper'
      },
    }
  },
  mounted() {
    this.courseCoursewareFavoriteLoaded = false;
  },
  methods: {
    initCourseCoursewareFavorite() {
      if (this.courseCoursewareFavoriteLoaded) {
        return;
      }

      this.getCourseCoursewareFavoriteList();
    },
    getCourseCoursewareFavoriteList() {
      this.courseCoursewareFavoriteLoaded = true;
      let params = {
        current: this.courseCoursewareFavoritePage.currentPage,
        size: this.courseCoursewareFavoritePage.pageSize,
        id: this.courseCoursewareId
      }
      fetchCourseCoursewareFavoriteList(params).then(response => {
        if (response.data.data != null) {
          this.courseCoursewareFavoriteData = response.data.data.records;
          this.courseCoursewareFavoriteData.forEach(favorite => {
            favorite.favoriteByRealname = favorite.favoriteByMemberType === 1
              ? favorite.favoriteByRelatedPersonalRealname
              : favorite.favoriteByRealname;
          });
          this.courseCoursewareFavoritePage.total = response.data.data.total;
        } else  {
          this.courseCoursewareFavoriteData = []
          this.courseCoursewareFavoritePage.total = 0;
        }
      }).catch(error => {
        this.$message({
          showClose: true,
          message: '获取收藏列表失败',
          type: 'error'
        });
      });
      this.courseCoursewareFavoriteLoaded = false;
    },
    courseCoursewareFavoriteCurrentChange(val) {
      this.courseCoursewareFavoritePage.currentPage = val;
      this.getCourseCoursewareFavoriteList();
    },
    courseCoursewareFavoriteSizeChange(val) {
      this.courseCoursewareFavoritePage.pageSize = val;
      this.getCourseCoursewareFavoriteList();
    },
  }
}
